module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAfCAYAAADEFbwbAAAAAXNSR0IArs4c6QAAAHhJREFUOE9jZMABGFVy/7MLcjF0Mv7/H8vAyMDyn+H/pPff7rUwmpb/bWdkYKxA1viP4f9kRtOyfx8YGRn4kSX+/2d4w2hW/u8/NmtGJTBCZTRIqBIkZf/OMzAyGKCkRAaGM4ymZf+dGRn/b2FgYOCASv74/4/RAwCISGNYlwpYvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/home/line1.png
// module id = tSih
// module chunks = 1